import { render, staticRenderFns } from "./relatedManufacture.vue?vue&type=template&id=76df1c8a&scoped=true"
import script from "./relatedManufacture.vue?vue&type=script&lang=js"
export * from "./relatedManufacture.vue?vue&type=script&lang=js"
import style0 from "./relatedManufacture.vue?vue&type=style&index=0&id=76df1c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df1c8a",
  null
  
)

export default component.exports